<template>
    <div class="inner-box">
        <!-- AS 접수제품 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `AS접수제품` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray" @click="openModel" v-show="showSave">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        모델선택
                        </button>
                        <button class="btn-size btn-gray" @click="deleteRow(1)" v-show="showSave">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        삭제
                        </button>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :context="context"
                            :column-defs="columnDefs"
                            :grid-options="mainGridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadyMain"
                            @cell-value-changed="MaincellValueChange"
                            @cell-clicked="onMainCellClicked"
                            editType="fullRow" />
                    </div>
                </div>
            </div>
        </div>
        <!-- AS 접수제품 그리드 e.-->
        <!-- 고장증상 그리드 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `고장증상` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray fl_left" @click="breakOpenModal" v-show="showSave">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        추가
                        </button>
                        <button class="btn-size btn-gray fl_left" @click="deleteRow(2)" v-show="showSave">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        삭제
                        </button>
                    </div>
                    
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="subGrid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            :enableRangeSelection="true"
                            :column-defs="subColumnDefs"
                            :grid-options="subGridOptions"
                            :row-data="subData"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            :stopEditingWhenCellsLoseFocus="true"
                            @cell-value-changed="SubCellValueChange"
                            @grid-ready="onReadySub"
                            />
                    </div>
                </div>
            </div>
        </div>
        <!-- 고장증상 그리드 e.-->
        <!-- Editor s.-->
        <div class="table-area">
            <div class="table-b">
                <el-row class="demo-autocomplete" :gutter="24">
                    <el-col :span="12">
                        <div class="sub-title">
                            <div class="table-name">
                                <h3 class="ico_table_name">{{ `고객요구사항` }}</h3>
                            </div>
                        </div>
                        <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 6}"
                        placeholder="요구사항을 작성하세요."
                        v-model="form.callMemo">
                        </el-input>
                        <div class="grid-content bg-purple"></div>
                    </el-col>
                    <el-col :span="12">
                        <div class="sub-title">
                            <div class="table-name">
                                <h3 class="ico_table_name">{{ `특이사항` }}</h3>
                            </div>
                        </div>
                        <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 6}"
                        placeholder="특이사항을 작성하세요."
                        v-model="form.visitMemo">
                        </el-input>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- Editor e.-->
        <!-- AS 배정 s.-->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `AS 배정` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray fl_left" @click="proc" v-show="showSave">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        저장
                        </button>
                    </div>
                </div>
                <el-form size="mini">
                    <el-row class="demo-autocomplete" :gutter="24">
                        <el-col :span="24">
                            <el-col :span="6">
                                <el-form-item label="처리센터">
                                    <el-input v-model="form.asAgentNm" readonly></el-input>
                                    <el-input v-model="form.asAgentId" v-show="false"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="처리기사">
                                    <el-row>
                                        <el-col :span="24">
                                            <el-col :span="20">
                                                <el-input v-model="form.userNm" readonly>
                                                </el-input>
                                                <el-input v-model="form.userId" v-show="false"></el-input>
                                            </el-col>
                                            <el-col :span="4">
                                                <el-button type="primary" icon="el-icon-search" @click="openModelAtcor" v-show="showSave"></el-button>
                                            </el-col>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="배정일시">
                                    <el-input v-model="form.allocationDt" readonly></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="출장급지">
                                    <el-select class="select" v-model="form.tripGrade" style="width: 100%;">
                                        <el-option
                                        v-for="item in tripGradeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        :disabled="false">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="6">
                                <el-form-item label="신고자명">
                                    <el-input v-model="form.custNm"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="신고자 전화번호">
                                    <el-input v-model="form.telNo"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="요청일">
                                <el-date-picker type="date" placeholder="요청일" v-model="form.requestVisitDt" style="width: 100%;" value-format="yyyy-MM-dd" :picker-options="datePickerOptions">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="요청시간"><br>
                                    <el-select class="select" v-model="form.requestVistHh" style="width: 30%;">
                                        <el-option
                                        v-for="item in requestVistHhList"
                                        :key="item.value"
                                        :value="item.value"
                                        :label="item.label"
                                        :disabled="false">
                                        </el-option>
                                    </el-select>
                                    <el-select class="select" v-model="form.requestVistMm" style="width: 30%;">
                                        <el-option
                                        v-for="item in requestVistMmList"
                                        :key="item.value"
                                        :value="item.value"
                                        :label="item.label"
                                        :disabled="false">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <!-- AS 배정 e.-->
    </div>
</template>


<script>
function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';
// import DatepickerCellRenderer from '@/components/agGrid/datepicker-cell-renderer';
import DatepickerCellRenderer from '@/components/elementUI/datepicker-cell-renderer';
import MaskEditCellRenderer from '@/components/agGrid/maskedit-cell-renderer';
import SelectCellRenderer from '@/components/agGrid/select-cell-renderer';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import RadioCellRenderer from '@/components/agGrid/radio-cell-renderer';
import NumberInputCellRender from '@/components/agGrid/numberinput-cell-renderer';
import InputCellRender from '@/components/agGrid/input-cell-renderer';
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer';
import ProductMenu from '@/components/AS/Receipt/Modal/ProductMenu.vue';
import SelectCellRendererSecondary from '@/components/agGrid/select-cell-renderer-secondary';

/**
 * * Modal
 */
import ReceptionModal from '@/components/AS/Receipt/Modal/ReceptionModal.vue';
import ModelSpec from '@/components/LucomsModal/ModelSpec.vue';
import ModelBreak from '@/components/LucomsModal/ModelBreak.vue';
import ModelActor from '@/components/LucomsModal/ModelActor.vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

const options = {};

export default {
    mixins: [slip, common],
    props: ['custParam'],
    components: {AgGridVue, DhxCalendar},
    data() {
        return {
            input1: '',
            value: '1',
            options: [
                {
                    value: '1',
                    label: '서울'
                },
                {
                    value: '2',
                    label: '경기도'
                },
            ],
            combos: ['asClass3'],
            asClassOpt: [{ key: '1', value: '부산'}], /** 접수유형 */
            asClassOptId: [],   /** 접수유형 */
            subAsClassOpt: [],   /** 세부유형 */
            data: [],
            subData: [],
            delChkList: [],
            delSubChkList: [],
            tripGradeList: [],  /** 출장급지 리스트 */
            requestVistHhList: [], /** 일시 : 시 */
            requestVistMmList: [], /** 일시 : 분 */
            selModelObj: {},    /** AS접수제품 클릭하여 선택된 모델 */
            guaranteeMonth: '', /** 보증개월수 */
            form: {
                custNm : '',
                custType : 'Default',
                propensity : 'Default',
                propensityBigo: '', 
                positionNm: '', 
                hpNo: '', 
                officeTelNo: '', 
                etcTelNo1: '', 
                etcTelNo2: '', 
                boundTelNo: '', 
                smsYn: 'Y', 
                telYn: '',
                addr1: '',
                addr2: '',
                zipCd: '',
                zipCd1: '',
                juminNo: '',
                callMemo: '', /** 고객요구사항 */
                visitMemo: '', /** 특이사항 */
                areaAgent: '', /** 지역ID */
                asAgentId: '', /** 처리센터 ID */
                asAgentNm: '', /** 처리센터 */
                userNm: '', /**처리기사 */
                userId: '', /**처리기사 */
                allocationDt: '', /** 배정일시 */
                tripGrade: 'X', /** 출장급지 */
                custNm: '', /** 신고자명 */
                telNo: '', /** 신고자 전화번호 */
                requestVisitDt: '', //this.$moment().format('YYYY-MM-DD'), /** 요청일시 : 처리기사 팝업에서 지정한 날짜 */
                requestVistHh: '', /** 요청일시 시간 */
                requestVistMm: '' /** 요청일시 분 */
            },
            showSave: true, /** 저장버튼 표시여부 */
            subChanged: false,

            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 190px; min-height:100px;',
            context: {
                // context is used as a global variable
                editorUpdateMethods: {},
                editorRefs: {},
                getRefData: this.getRefData,
            },
            defaultColDef: {
                resizable: true
                , filter: true
                , sortable: true
            },
            mainGridApi: null,
            mainColumnApi: null,
            subGridApi: null,
            subColumnApi: null,
            columnDefs: [],
            subColumnDefs: [],
            mainGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            subGridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                datePicker: DatepickerCellRenderer,
                maskEdit: MaskEditCellRenderer,
                select: SelectCellRenderer,
                checkBox: CheckboxCellRenderer,
                radio: RadioCellRenderer,
                numberInput: NumberInputCellRender,
                input: InputCellRender,
                button: ButtonCellRenderer,
                secondarySelect: SelectCellRendererSecondary,
            },
            topDownData: [],
            //AG-GRID OPTION [END]
            datePickerOptions: {
                disabledDate (date) {
                    return date < new Date('1971-01-01')
                }
            },
        }
    },
    computed: {
        
    },
    mounted() {
        //console.log('mounted custParam ddd2 : ', _.cloneDeep(this.custParam));
        this.showSave = true;
        let i = 0
        // 일시 : 시간
        for(i=9; i<=20; i++){
            const vLabel = ( (i < 10) ? '0' + i.toString() : i.toString() ) + '시';
            const vHh = {key: i.toString(), value: i.toString(), label: vLabel}
            this.requestVistHhList.push(vHh);
        }
        this.requestVistHhList.unshift({key:'', value:'', label: '선택'});

        // 일시 : 분
        for(i=0; i < 6; i++){
            let vLabel = '0' + i.toString() + '분';
            if(i>0){
                vLabel = i.toString() + '0분';
            }
            const vMm = {key: (i*10).toString(), value: (i*10).toString(), label: vLabel}
            this.requestVistMmList.push(vMm);
        }
        this.requestVistMmList.unshift({key:'', value:'', label: '선택'});

        console.log('===Receipt custParam: ', this.custParam);

        this.setReciptList();   
        
        //===세션정보가 있을경우 셋팅====
        const vAsReceipt = JSON.parse(sessionStorage.getItem(this.$parent.asSessionKey + "asReceipt"));
        if(vAsReceipt && vAsReceipt.loginId === this.$store.state.loginInfo.loginId){
            this.data = vAsReceipt ? vAsReceipt.modelData : []; //AS접수제품
            this.form = vAsReceipt ? vAsReceipt.formData : {};

        } else {
            if(vAsReceipt){
                sessionStorage.removeItem(this.$parent.asSessionKey + "asReceipt");      // AS접수제품 초기화
            }
        }
        
        if(this.custParam.applySearchCond){
            // search 컴포넌트의 조회조건 적용 : sessionStorage보다 search변경이 우선
            this.applySearchCond(this.custParam.applySearchCond);
            delete this.custParam.applySearchCond;
        }

        console.log('this.subData : ', this.subData);
        const vAsModelBreak = JSON.parse(sessionStorage.getItem(this.$parent.asSessionKey + "asModelBreak"));
        console.log('mount vAsModelBreak: ', vAsModelBreak);
        
        if(vAsModelBreak && vAsModelBreak.loginId === this.$store.state.loginInfo.loginId){
            this.subData = vAsModelBreak ? vAsModelBreak.modelBreak : []; //고장증상
            
        } else {
            if(vAsModelBreak){
                sessionStorage.removeItem(this.$parent.asSessionKey + "asModelBreak");   // 고장증상 초기화
            }
        }
    },
    methods: {
        onReadyMain() {
            // AS접수제품 그리드 api 정의
            this.mainGridApi = this.mainGridOptions.api;
            this.mainColumnApi = this.mainGridOptions.columnApi;
            this.getGuaranteeMonth();
            this.getCombo({flag: 'INIT'});
        },
        onReadySub() { 
            // 고장증상 그리드 api 정의
            this.subGridApi = this.subGridOptions.api;
            this.subColumnApi = this.subGridOptions.columnApi;
            this.createSubColumnDefs();
        },
        getGuaranteeMonth(){
            // 보증개월수 조회  
            this.$http.get(`/api/asMng/call/config`, {params: {keyPath: 'System.DefaultGuaranteeMonth'}})
                    .then(response => {
                        this.guaranteeMonth = response.data[0].configValue || ''
                         console.log('this.guaranteeMonth: ', this.guaranteeMonth) 
                    });
                
        },
        async getCombo(param) {
            if(param.flag === 'INIT'){
                // 접수유형 : AsClass 2레벨
                const runA = this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'AsClass'}})
                    .then(response => {
                        this.asClassOpt = _.cloneDeep(response.data
                                                            .filter(x=>x.catLvl==2)
                                                            .map(y=>{
                                                                y.key = y.catKey;
                                                                y.value = y.catNm;
                                                                return {key: y.key, value: y.value};
                                                            })
                        ) || [];
                        this.asClassOpt.unshift({key:'', value:'선택'})                                    

                        this.combos['asClass3'] = _.cloneDeep(response.data
                                                            .filter(x=>x.catLvl==3)
                                                            .map(y=>{
                                                                y.key = y.catKey;
                                                                y.value = y.catNm;
                                                                return {key: y.key, value: y.value};
                                                            })
                         ) || [];
                                                            
                        this.subAsClassOpt = [{key:'', value:'선택'}, {key:'a', value:'a'}, {key:'b', value:'b'}, {key:'c', value:'c'}]
                        
                        console.log('getCombo this.asClassOpt: ', this.asClassOpt)
                    });

                const runB =  this.$http.post(`/api/asMng/call/getTopDownData`, {topKey: 'AsClass'})
                    .then(response => {
                        this.topDownData = response.data;
                    });
        
                const runC = this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 89}})
                    .then(response => {
                        this.asClassOptId = response.data || []
                        this.asClassOptId.unshift({key:'', value:'선택'})
                    }); 
                    
                // 출장급지 : TripGrade 2레벨
                const runD = this.$http.get(`/api/codeMng/combo`, {params: {parentId: 305}})
                    .then(response => {
                        console.log(' 출장급지: ', response.data);
                        this.tripGradeList = response.data || [];
                        this.form.tripGrade = '무급지';
                    });
                
                this.$store.commit('loading');

                await Promise.all([runA, runB, runC, runD]);
                await this.createMainColumnDefs();

                this.$store.commit('finish');

            } else {
                 
                if(param.key === ''){
                    this.subAsClassOpt = []
                    this.subAsClassOpt.unshift({key:'', value:'선택'})
                } else {
                    console.log('getCombo sub param: ', param)
                    const vModelIdx = this.asClassOpt.findIndex(x=>x.key === param.key)
                    console.log('getCombo response.data 12: ', this.asClassOptId[vModelIdx])
                    // 세부유형 : AsClass 2레벨
                    await this.$http.get(`/api/codeMng/combo`, {params: {parentId: this.asClassOptId[vModelIdx].key}})
                        .then(response => {
                            
                            this.subAsClassOpt = response.data || []
                            this.subAsClassOpt.unshift({key:'', value:'선택'});

                            // this.$refs.grid[param.idx-1].columnDefs[11].cellRendererParams.options.length = 0;
                            
                            this.subAsClassOpt.forEach(x => {
                                this.$refs.grid[param.idx-1].columnDefs[11].cellRendererParams.options.push(x);    
                            })
                            
                            this.mainGridApi.refreshCells({ payYn: 'N' });
                            this.mainGridRefresh(param.idx);
                        });
                }
                
            }

        },
        async createMainColumnDefs() {
            const that = this;
            this.columnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {
                    headerName:'No',
                    field:'no', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    }
                },
                {
                    headerName:'제조사',
                    field:'maker', 
                    width:100,
                    hide: true,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width:100,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'제품군',
                    field:'modelGroupNm', 
                    width:100,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'대표모델',
                    field:'standardModelNm', 
                    width:120,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'모델CD',
                    field:'modelCd', 
                    width:100,
                    hide: true
                },
                {
                    headerName:'모델',
                    field:'modelNm', 
                    width:150,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: (params) => {
                        return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
                    }
                },
                {
                    headerName:'제조번호',
                    field:'serialNo', 
                    width:110,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'대수',
                    field:'qty', 
                    width:90,
                    editable : true,
                    cellRenderer: 'numberInput',
                    cellStyle:{textAlign: 'center', backgroundColor: '#fff8f7'},
                    valueFormatter: (params) => {
                        return that.getNumberFormat(params.value);
                    }
                },
                {
                    headerName:'보증만료일',
                    field:'guaranteeEndDt', 
                    width:120,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: (params) => {
                        return params.value ? that.$moment(params.value).format('YYYY-MM-DD') : '';
                        // return (params.value && params.value.length >= 6) ? params.value.substring(0,4) + '-' + params.value.substring(4) : '' ;
                    }
                },
                {
                    headerName:'구입년월',
                    field:'purchaseDt',
                    width:120,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'datePicker',
                    cellRendererParams: {
                        // 참고 문서 : https://element.eleme.io/#/en-US/component/date-picker#attributes
                        type: 'month',
                        format: 'yyyy-MM',  //date format
                        valueFormat: 'yyyyMM',  //받는 model 의 결과 포맷
                        disable: false, //disabled 처리
                    }
                },
                {
                    headerName:'접수유형',
                    field:'asClass', 
                    width:110,
                    editable : true,
                    cellStyle:{textAlign: 'center'},
                    cellEditor: 'secondarySelect',
                    cellEditorParams: { 
                        values: that.topDownData.ROOT.map(x=>x.value), focusOnEditStart: true 
                    },
                    // cellRenderer: 'select',
                    // cellRendererParams: {
                    //     // options : options["asClassOpt"],
                    //     options : that.asClassOpt,
                    //     detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
                    //     detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
                    // },
                    // onCellValueChanged : (params) => {
                    //     if (params.oldValue !== params.newValue) {
                    //         console.log('onCellValueChanged kkkk2: ', params)
                       
                    //     //현재 셀의 object변경시킴
                    //     /*
                    //         params.colDef.cellRendererParams.options = [{key:'', value:'선택'}, {key: params.newValue, value: params.newValue}]
                    //         params.data.subAsClass = params.newValue; // assign to new adjacent column
                    //         params.api.refreshCells({columns : ["subAsClass"]}) ;
                    //        */
 
                             
                             
                    //     }
                    // } 
                },
                {
                    headerName:'세부유형',
                    field:'subAsClass', 
                    width:130,
                    editable : true,
                    cellStyle:{textAlign: 'center'},
                    cellEditor: 'secondarySelect',
                    cellEditorParams: ({ data }) => 
                        this.getDropDownEditorParams('asClass', data, this.getRefData),
                    // cellRenderer: 'select',
                    // cellRendererParams: {
                    //     // options : options["asClassOpt"],
                    //     options : that.subAsClassOpt,
                    //     detailCd: 'key',  //서버로 부터 받은 key defalut-"detailCd"
                    //     detailNm: 'value' //서버로 부터 받은 value defalut-"detailNm"
                    // }
                    
                },
                {
                    headerName:'유/무상',
                    field:'payYn', 
                    width:110,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'radio',
                    cellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                    }  
                },
                {
                    headerName:'보증개월수',
                    field:'guaranteeMonth', 
                    width:100,
                    hide:false
                }
            ];
        },
        createSubColumnDefs() {
            this.subColumnDefs = [
                {
                    headerName:'선택',
                    field:'chk', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    cellRenderer: 'checkBox',
                    ellRendererParams: {
                          trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                        , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                        , disable: true
                    },
                },
                {
                    headerName: '고장증상구분', 
                    field:'gbCd', /** 카테고리3레벨 */
                    width: 130,
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '고장증상명', 
                    field:'gbNm', /** 카테고리4레벨 */
                    width: 340,
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '상세증상', 
                    field:'description', 
                    width: 1000,
                    editable: true,
                    cellStyle:{textAlign:'left', backgroundColor: '#fff8f7'},
                    cellDataType: false,
                    cellRendererParams: {
                        obj: {
                            placeholder: "상세증상을 입력하세요."
                        }
                    }
                },
                {
                    headerName: 'AS_DETAIL_ID', 
                    field:'asDetailId',
                    hide: true,
                    suppressToolPanel: true
                },
                {
                    headerName: 'AS_CAT_ID', 
                    field:'asCatId',
                    hide: true,
                    suppressToolPanel: true
                },
                {
                    headerName: 'AS_CAT_IDX', 
                    field:'asCatIdx',
                    hide: true,
                    suppressToolPanel: true
                },
            ];
        },
        onMainCellClicked(params) {
            /** AS접수제품 모델선택시 */
            const idx = params.rowIndex;
            const field = params.colDef.field;
            console.log('onMainCellClicked start ', params)
            // console.log('onMainCellClicked subData ', this.subData)

            if(field === 'modelNm') {
                this.openModelSpec(params.data);
            }

            if(params.data){
                this.selModelObj = { ...params.data, curIdx: idx}
                this.subData = params.data.subData || []
            }

            //this.setGridSessionInfo()
        },
        SubCellValueChange(params){
            /** 고장증상 셀변경시 */
            const subIdx = params.rowIndex;

            console.log('SubCellValueChange start: ', params)
            if(this.selModelObj){
                const dataIdx = this.selModelObj.curIdx
                this.data[dataIdx].subData[subIdx].description = this.subData[subIdx].description || '';
                this.subChanged = true;
            }
            console.log('SubCellValueChange start2: ', this.data)

            // this.setGridSessionInfo()
            
        },
        MaincellValueChange(params){
            /** AS접수제품 셀변경시 */

            if(this.subChanged){
                this.subChanged = false;
                return false;
            }

            const idx = params.rowIndex;
            console.log('MaincellValueChange start: ', params)
            
            /** AS접수제품 체크박스 변경시 */
            if(params.colDef.field === 'asClass'){
                // this.getCombo({flag: '', key: params.value, idx});
                console.log('subAsClassOpt aaa :', this.subAsClassOpt )
                this.subAsClassOpt=this.subAsClassOpt.filter(x=>(x.key===''||x.key==='b')) 
                console.log('this.columnDefs[idx] aaa :', this.subAsClassOpt, this.columnDefs[11])
                this.mainGridApi.redrawRows({ rowNodes: params });
            } else if(params.colDef.field === 'guaranteeEndDt'){
                //this.mainGridApi.redrawRows({ rowNodes: params });
            } else if(params.colDef.field === 'purchaseDt'){
                console.log("purchaseDt ", params)
                // params.value: YYYYMM
                const vPurchaseDt = this.$moment(params.value).format('YYYYMMDD')
                
                if(vPurchaseDt.length >= 8){
                    let date = this.$moment(vPurchaseDt).format('YYYY-MM');// new Date(Number(vPurchaseDt.substring(0,4)) , Number(vPurchaseDt.substring(4,6)), 1);
                    if(params.data.guaranteeMonth && Number(params.data.guaranteeMonth) > 0){
                        // 모델의 보증기간이 있는 경우
                        date = this.$moment(date).add(Number(params.data.guaranteeMonth), 'month').add(1, 'month').subtract(1, 'day');
                    } else {
                        // 모델의 보증기간이 없는 경우 기본 보증기간으로 계산
                        date = this.$moment(date).add((Number(this.guaranteeMonth) || 12), 'month').add(1, 'month').subtract(1, 'day');
                    }
                    
                    let timezoneOffset = date._d.getTimezoneOffset()* 60 * 1000;
                    params.data.guaranteeEndDt = new Date(date._d.getTime() - timezoneOffset);
                    // 전화한 날짜가 보증일의 말일보다 크면 유상처리
                    let sCallDt = ''; //시스템 현재시간 조회
                    this.$http.get(`/api/asMng/call/curTime`)
                    .then(response => {
                        if(response.data && response.data.length >=10){
                            // sCallDt : YYYY-MM-DD
                            sCallDt = response.data.substring(0,10) || '';
                            
                            params.data.asClass = "AS";
                                
                            if(this.$moment(params.data.guaranteeEndDt).format('YYYYMM') < this.$moment(response.data).format('YYYYMM')){
                                params.data.payYn = "Y";
                                //params.data.subAsClass = "AB";
                                params.data.subAsClass = "유상수리";
                            } else {
                                params.data.payYn = "N";
                                //params.data.subAsClass = "AA";
                                params.data.subAsClass = "무상수리";
                            }
                        }

                        params.data.purchaseDt = vPurchaseDt; 
                        this.mainGridApi.redrawRows({ rowNodes: params });

                        
                    }); 
                    
                } else {
                    params.data.guaranteeEndDt = ""
                    params.data.payYn = "N"
                    params.data.asClass = ""
                }
                
            }
            
            this.mainGridRefresh(idx)
        },
        
        mainGridRefresh(idx) {
            var rows = [];
            var rowNode = this.mainGridApi.getDisplayedRowAtIndex(idx);
            rows.push(rowNode);
            this.mainGridApi.redrawRows({ rowNodes: rows });
        },
        proc() {
            /** 하단의 저장버튼 : AS접수제품을 저장처리 */

            if(!this.$parent.$refs.refSearchForm.custValidate()){
                // searchForm의 조회조건 체크
                return false;
            }

            let vData = _.cloneDeep(this.data);
            console.log('proc start :', this.data)
            /** 체크로직 */
            if(vData.length === 0){
                this.$swal({
                    type: 'warning',
                    text: '하나 이상 AS접수제품을 등록해 주십시오.'
                });

                return false
            }
            
            let vNotExistEndDt = 'N';
            vData = vData.map(x=>{
                if(x.guaranteeEndDt){
                    let vGuaranteeEndDt = '';
                    try{
                        vGuaranteeEndDt = x.guaranteeEndDt.toISOString() || '';
                    } catch(e){
                        vGuaranteeEndDt = x.guaranteeEndDt || '';
                    }
                    
                    if(vGuaranteeEndDt.length>=10){
                        x.guaranteeEndDt = vGuaranteeEndDt.substring(0,10);
                    } else {
                        vNotExistEndDt = 'Y';
                    }
                } else {
                    vNotExistEndDt = 'Y';
                }
                
                return x;
            });

            if(vNotExistEndDt === 'Y'){
                this.$swal({
                    type: 'warning',
                    text: '구입년월을 등록해 주십시오.'
                });

                return false
            }

            const vQtyStr = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.qty || x.qty === '').map(y=>{return y.no}).join(',')
            
            if(vQtyStr && vQtyStr.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vQtyStr + '번 AS접수제품의 대수를 정확하게 입력해 주십시오.'
                });

                return false
            }

            const vQtyZeroStr = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>x.qty <= 0).map(y=>{return y.no}).join(',')
            if(vQtyZeroStr && vQtyZeroStr.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vQtyZeroStr + '번 AS접수제품의 대수에 1개 이상의 값을 입력해 주십시오.'
                });

                return false
            }

            const vOldPurchaseDt = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>x.purchaseDt && x.purchaseDt.length >= 8 && x.purchaseDt < '19700101').map(y=>{return y.no}).join(',');
            if(vOldPurchaseDt && vOldPurchaseDt.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vOldPurchaseDt + '번 AS접수제품의 구입년월을 1970년 이후로 선택해 주십시오.'
                });

                return false
            }

            const vPurchaseDt = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.purchaseDt || x.purchaseDt.length < 8).map(y=>{return y.no}).join(',')
            if(vPurchaseDt && vPurchaseDt.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vPurchaseDt + '번 AS접수제품의 구입년월을 선택해 주십시오.'
                });

                return false
            }

            const vAsClass = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.asClass || x.asClass==='').map(y=>{return y.no}).join(',')
            if(vAsClass && vAsClass.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vAsClass + '번 AS접수제품의 접수유형을 선택해 주십시오.'
                });

                return false
            }

            // const test = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.subAsClass || x.subAsClass==='')
            // console.log('subAsClass data : ', test)

            /*
            const vSubAsClass = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.subAsClass || x.subAsClass==='').map(y=>{return y.no}).join(',')
            if(vSubAsClass && vSubAsClass.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vSubAsClass + '번 AS접수제품의 세부유형을 선택해 주십시오.'
                });

                return false
            }

            const vPayYn = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.payYn || x.payYn==='').map(y=>{return y.no}).join(',')
            if(vPayYn && vPayYn.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vPayYn + '번 AS접수제품의 유/무상을 선택해 주십시오.'
                });

                return false
            }
            */

            const vBreakCnt = vData.map((s,index)=>{s.no=index+1; return s}).filter(x=>!x.subData).map(y=>{return y.no}).join(',')
            if(vBreakCnt && vBreakCnt.length > 0){
                this.$swal({
                    type: 'warning',
                    text: vBreakCnt + '번 AS접수제품의 고장증상을 등록해 주십시오.'
                });

                return false
            }

            if(!this.form.userId || this.form.userId === ''){
                this.$swal({
                    type: 'warning',
                    text: '처리기사를 선택해 주십시오.'
                });

                return false
            }
 
            // 필수가 아니라고 함. 2023-04-04
            if(!this.form.tripGrade || this.form.tripGrade === ''){
                this.$swal({
                    type: 'warning',
                    text: '출장급지를 선택해 주십시오.'
                });

                return false
            }
 
            if(this.form.requestVisitDt==='' || this.form.requestVisitDt==null){
                this.$swal({
                    type: 'warning',
                    text: '요청일시를 선택해 주십시오.'
                });

                return false
            }

            if(this.form.requestVistHh===''){
                this.$swal({
                    type: 'warning',
                    text: '일시를 선택해 주십시오.'
                });

                return false
            }

            const vTripGradeCd = this.tripGradeList.filter(x=>x.value === this.form.tripGrade).map(x=>{return x.key || ''}); 
            // console.log('vTripGradeCd : ', this.form.tripGrade, this.tripGradeList, vTripGradeCd);
            const vTripGradeCd2 = vTripGradeCd && vTripGradeCd.length>0 ? vTripGradeCd[0] : '';
            // console.log('vData before : ', vData);

            const vChgData = vData.map(x=>{
                const vGuaranteeStartDt = x.guaranteeStartDt && x.guaranteeStartDt.length == 6 ? x.guaranteeStartDt.substring(0,4) + '-' + x.guaranteeStartDt.substring(4) + '-01 00:00:00' : '1900-01-01 00:00:00';
                const vGuaranteeEndDt = x.guaranteeEndDt && x.guaranteeEndDt.length == 10 ? x.guaranteeEndDt + ' 00:00:00' : '1900-01-01 00:00:00';
                const vPurchaseDt = x.purchaseDt && x.purchaseDt.length == 8 ? x.purchaseDt.substring(0,4) + '-' + x.purchaseDt.substring(4,6) + '-' + x.purchaseDt.substring(6) + ' 00:00:00' : '1900-01-01 00:00:00';
                // console.log('vGuaranteeEndDt: ', x.guaranteeEndDt, vGuaranteeEndDt);
                // console.log('vPurchaseDt: ', x.purchaseDt, vPurchaseDt);
                x.guaranteeStartDt= vGuaranteeStartDt;
                x.guaranteeEndDt = vGuaranteeEndDt;
                x.purchaseDt = vPurchaseDt;
                x.prodDt = x.prodDt ? x.prodDt + ' 00:00:00' : '1900-01-01 00:00:00';
                x.payYn = x.payYn ? x.payYn : 'Y';
                x.serialNo = x.serialNo ? x.serialNo : '';

                const vAsClassObj = this.asClassOpt.filter(y=>y.key===x.asClass || y.value===x.asClass);
                if(vAsClassObj && vAsClassObj.length>0){
                    x.asClass = vAsClassObj[0].key;
                }

                const vSubAsClassObj = this.combos['asClass3'].filter(y=>y.key===x.subAsClass || y.value===x.subAsClass);
                if(vSubAsClassObj && vSubAsClassObj.length>0){
                    x.subAsClass = vSubAsClassObj[0].key;
                }

                x.subData.map(y=>{
                    if(!y.description){
                        y.description = '';
                    }
                    
                    return y;
                })

                return x;
            })

            // console.log('vData after : ', vChgData)
            const vRequestVistHh = this.form.requestVistHh.length === 1 ? '0' + this.form.requestVistHh : this.form.requestVistHh;
            const vRrequestVistMm = this.form.requestVistMm.length === 1 ? '0' + this.form.requestVistMm : this.form.requestVistMm;
            
            const vCurDt = this.$moment().format('YYYY-MM-DD HH:mm:ss');
            let vRequestVisitDt = vCurDt;
            if(this.form.requestVisitDt != '' && vRequestVistHh != '' && vRrequestVistMm != ''){
                vRequestVisitDt = this.form.requestVisitDt + ' ' + vRequestVistHh + ':' + vRrequestVistMm+ ':00'|| '';
            }

            if(vRequestVisitDt < vCurDt){
                this.$swal({
                    type: 'warning',
                    text: vAsClass + '현재시간 이후로 선택해 주세요.'
                });

                return false;
            }

            let vTelNo = this.form.telNo === '' ? this.form.boundTelNo || '' : '';
            vTelNo = this.form.telNo === '' ? this.form.hpNo || '' : '';
            vTelNo = this.form.telNo === '' ? this.form.custTelNo || '' : '';

            let vCallDt = this.$parent.search.callDt || '';
            if(vCallDt && vCallDt.length==16){
                vCallDt = vCallDt + ':00'; 
            } else {
                vCallDt = this.$moment().format('YYYY-MM-DD HH:mm:ss'); /** 통화일시 */
            }
            
            if(this.form.custNm ===''){
                this.form.custNm = this.$parent.search.custNm || '';
            }

            if(this.form.addr1 ===''){
                this.form.addr1 = this.$parent.search.addr1 || '';
            }

            if(this.form.addr2 ===''){
                this.form.addr2 = this.$parent.search.addr2|| '';
            }

            if(this.form.zipCd1 ===''){
                this.form.zipCd = this.$parent.search.zipCd1 || '';
                this.form.zipCd1 = this.$parent.search.zipCd1 || '';
            }

            if(this.form.telNo ===''){
                this.form.telNo = this.$parent.search.telNo|| '';
            }

            if(this.form.hpNo ===''){
                this.form.hpNo = this.$parent.search.hpNo|| '';
            }

            if(this.form.boundTelNo ===''){
                this.form.boundTelNo = this.$parent.search.boundTelNo|| '';
            }

            let vSaveform0 ={
                ...this.form,
                custNm: this.$parent.search.custNm || '', /** 조회조건 */
                custId: this.$parent.search.custId || '', /** 조회조건 */
                boundCustNm: this.form.custNm || '', /** 신고자명 */
                custGb: '1', /** 조회조건 */
                codeNm: '', /** 조회조건 */
                useType: 'Y', /** 조회조건 */
                inType: this.$parent.search.inType || '', /** 조회조건 */
                inTypeVal: this.$parent.search.inTypeVal || '', /** 조회조건 */
                callDt: vCallDt,
                actTab: 'AS_TAB', /** 활성탭 */
                boundId:'0',
                allocationAsAgentId: this.form.asAgentId || '0',
                allocationRepairId: this.form.userId || '0',
                requestVisitDt : vRequestVisitDt,
                tripGrade : vTripGradeCd2,
                asData : vChgData
            }

            vSaveform0 = JSON.parse(JSON.stringify(vSaveform0));
            
            const vvTelNo = vSaveform0.telNo || '';
            const vvHpNo = vSaveform0.hpNo || '';
            const vvBoundTelNo = vSaveform0.boundTelNo || '';

            vSaveform0 = {
                ...vSaveform0,
                telNo: vvTelNo,
                hpNo: vvHpNo,
                boundTelNo: vvBoundTelNo,
                workInYn: 'N'
            }
            const vSaveform = vSaveform0;

            const regex = /[^0-9]/g
            vSaveform.telNo = vSaveform.telNo.replace(regex, '');
            vSaveform.boundTelNo = vSaveform.boundTelNo.replace(regex, '');
            vSaveform.hpNo = vSaveform.hpNo.replace(regex, '');
            vSaveform.boundType = 'BT'; // 콜센터접수 접수
            vSaveform.custType = this.$parent.search.custType;
            
            console.log('vSaveform : ', vSaveform);

            this.$swal({
                type: 'warning',
                text: `AS내역을 저장 하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    this.$store.commit('loading');
                    this.$http.put('/api/asMng/call/saveCallAs', vSaveform, {timeout: 60000*30})
                        .then(response => {
                            console.log('save after response : ', response);
                            sessionStorage.removeItem(this.$parent.asSessionKey + "asModelBreak");
                            sessionStorage.removeItem(this.$parent.asSessionKey + "asReceipt");
                            this.data  = [];
                            this.subData = [];
                            
                            this.$swal({ type: 'success', text: 'AS내역이 저장되었습니다' });

                            // 초기화
                            this.$parent.$refs.refSearchForm.initCust('NO_ALERT');

                            // 재로딩
                            // this.$router.go(this.$router.currentRoute);
                            
                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'success', text: 'AS내역의 저장에 실패 했습니다.' });

                            // 초기화
                            this.$parent.$refs.refSearchForm.initCust('NO_ALERT');
                        })
                        .finally(() => {
                            this.$parent.$parent.openTodoListModal();
                            this.$store.commit('finish');
                        });

                }
            });
        },
        /**
         * AS 팝업 오픈
         * * AS접수 제품 모델 선택 팝업
         */
        openModel() {
            let vm = this;
            // console.log('$parent SearchForm:', this.$parent)
            this.$modal.open({
                width: 800,
                component: ReceptionModal,
                parent: this,
                props: {
                    data: [{'param': this.$parent.search}]
                },
                events: {
                    close(param) {
                        // console.log('openModel close', param.data, vm);
                        if(param.data){
                            vm.data = vm.data ? vm.data : [];
                            const  vData = {
                                ...param.data,
                                qty: 1
                            }
                            console.log('vm.data : ', vm.data);
                            vm.data.push(vData);
                        }
                        
                        var rowNode = vm.mainGridApi.getDisplayedRowAtIndex(vm.data.length-1);
                        if(param.data){
                            vm.selModelObj = { ...rowNode, curIdx: vm.data.length-1};
                            vm.subData = [];
                        }

                        //vm.setGridSessionInfo();
                        // console.log('vm store: ', vm)
                    },
                }
            });
        },
        /**
         * 처리기사 팝업 오픈
         */
        openModelAtcor() {
            const vm = this;
            let vSumQty = 0;
            this.data.map(x=>{
                if(x.qty && x.qty != ''){
                    vSumQty += Number(x.qty);
                }
                return x;
            });

            const vSrchObj = this.$parent.search;
            const vAreaAgent = (vm.form.areaAgent ? vm.form.areaAgent : vSrchObj.areaAgent) || '';
            let vAsAgentId = (vm.form.asAgentId ? vm.form.asAgentId : vSrchObj.asAgentId) || '';
            let vRepairId = (vm.form.userId ? vm.form.userId : vSrchObj.userId) || '';
            if(vAreaAgent == ''){
                vAsAgentId = '';
                vRepairId = '';
            }

            if(vAsAgentId == ''){
                vRepairId = '';
            }

            const vForm = {
                            addr1 : vSrchObj.addr1 || '',
                            addr2 : vSrchObj.addr2 || '',
                            areaAgent : vAreaAgent, /** 지역 ID*/
                            asAgentId : vAsAgentId, /** 센터ID */
                            repairId : vRepairId,
                            modelCnt : vSumQty
                        };
console.log('openModelAtcor vSrchObj: ', vSrchObj, vForm);
            this.$modal.open({
                component: ModelActor,
                parent: vm,
                width: 1000,
                props: {
                    data: vForm,
                },
                events: {
                    close(retData) {
                        console.log('openModelAtcor close', retData);
                        const data = _.cloneDeep(retData);
                        vm.form.areaAgent = data.areaAgent; /** 지역 ID */
                        vm.form.asAgentId = data.asAgentId; /** 처리센터 ID */
                        vm.form.asAgentNm = data.asAgentNm;
                        vm.form.userId = data.userId; /**처리기사 */
                        vm.form.userNm = data.userNm; /**처리기사 */
                        
                        vm.$parent.$refs.refSearchForm.tmpAreaAgent = data.areaAgent;
                        vm.$parent.$refs.refSearchForm.tmpAsAgentId = data.asAgentId;
                        vm.$parent.$refs.refSearchForm.tmpAsAgentNm = data.asAgentNm;
                        vm.$parent.$refs.refSearchForm.tmpUserId = data.userId;
                        vm.$parent.$refs.refSearchForm.tmpUserNm = data.userNm;
                                
                        vm.$parent.$refs.refSearchForm.lastBut = 'R'; // 마지막 조회버튼이 상단 조회버튼(S) or AS접수탭의 처리기사버튼(R) 여부

                        if(data.selField === ''){
                            vm.form.requestVisitDt = undefined;
                            vm.form.requestVistHh = '';
                            vm.form.requestVistMm = '';
                        } else {
                            if(data.selField === 'toMorn' || data.selField === 'toAfter') {
                                vm.form.requestVisitDt = vm.$moment().add(1, 'day').format('YYYY-MM-DD'); /** 익일 */
                            } else if(data.selField === 'dotMorn' || data.selField === 'dotAfter') {
                                vm.form.requestVisitDt = vm.$moment().add(2, 'day').format('YYYY-MM-DD'); /** 익익일 */
                            } else {
                                vm.form.requestVisitDt = vm.$moment().format('YYYY-MM-DD'); /** 당일 */
                            }

                            // 일시 셋팅
                            vm.form.requestVistMm = '0'; /** 요청일시 분 */
                            if(data.selField === 'after' || data.selField === 'toAfter' || data.selField === 'dotAfter') {
                                vm.form.requestVistHh = '13';  /** 요청일시 시간 : 오후 */
                            } else {
                                vm.form.requestVistHh = '9';  /** 요청일시 시간 : 오전 */
                            }
                        }
                        
                    },
                }
            });
        },
        /**
         * 모델 사양 팝업 오픈
         * * 그리드 상 모델 선택시 오픈되어지는 모델 사양
         */
        openModelSpec(param) {
            
            const vForm = {
                modelGroup: param.modelGroup,
                modelCd : param.modelCd
            };

            this.$modal.open({component: ProductMenu, parent: this, width: 1200, props: {data: vForm}});

        },
        /**
         * 고장증상 팝업 오픈
         * * AS접수 제품 모델 그리드 추가 이후 생성되어지는 고장증상 추가 버튼 클릭 오픈 팝업
         */
        breakOpenModal() {
            let vSrcObj = this.data
            
            if(!vSrcObj){
                this.$swal({
                type: 'warning',
                text: 'AS접수제품에서 선택된 행이 없습니다..'
                });

                return false
            } else if (vSrcObj.length === 1){
                // AS접수제품을 클릭안했더라도 한건뿐이면 강제로 선택시켜서 breakOpenModal 호출시킴.
                this.selModelObj =  { ...vSrcObj[0], curIdx: 0}
            }

            let vm = this;
            if(this.selModelObj.modelNm){
                const vSelModelObj = this.selModelObj
                this.$modal.open({
                    component: ModelBreak,
                    parent: this,
                    props: {
                        data: {
                            selModelObj: vSelModelObj
                        },
                    },
                    events: {
                        close(param) {
                            console.log('close', param);
                            console.log('close vm.subData: ', vm.subData);
                            if(param.data){
                                vm.subData = vm.subData ? vm.subData : []

                                param.data.forEach(x => {
                                    vm.subData.push(x)
                                })
                            }
                            
                            console.log('close vm.subData2: ', vm.subData);

                            // 선택된 AS접수제품에 subData을 맵핑
                            vm.subData.modelId = vm.data[vSelModelObj.curIdx].modelId || ''
                            vm.data[vSelModelObj.curIdx].subData = vm.subData
                            
                        },
                    }
                });
            } else {
                this.$swal({
                    type: 'warning',
                    text: 'AS접수제품에서 선택된 행이 없습니다.'
                    });
            }
            
        },
        deleteRow(vflag){ 
            let vSrcObj = this.data;
            
            if(vflag === 2){
                vSrcObj = this.subData;
            }

            let chkedObj = vSrcObj.filter(x=>x.chk==='Y');

            if(!vSrcObj || chkedObj.length === 0){
                this.$swal({
                type: 'warning',
                text: '선택된 행이 없습니다.'
                });

                return false;
            }

            const vLiveObj = vSrcObj.filter(x=>x.chk!='Y');
            vSrcObj = vLiveObj;

            if(vflag === 1){
                this.data = vLiveObj;

                // 선택된data 를 초기화후 0번째 셋팅                
                this.selModelObj = {}
                if(this.data && this.data.length>0){
                    this.selModelObj =  { ...this.data[0], curIdx: 0};
                    this.subData = this.data[0].subData || [];
                    this.data.map(x=>{x.chk='N'});
                    this.data[0].chk = 'Y';
                } else {
                    this.subData = [];
                }
                
                
            } else {
                this.subData = vLiveObj

                if(this.selModelObj){
                    const dataIdx = this.selModelObj.curIdx
                    this.data[dataIdx].subData = vLiveObj
                }
                
            }

        },
        getDropDownEditorParams(parentColumn, data, getRefData) {
            const parentCellValue = data[parentColumn];
            return {
                // the editor is provided with initial options for the select editor
                values: this.getRefData(parentCellValue),
                // and parent column name / colId
                cascadeFrom: parentColumn,
            };
        },
        getRefData(refKey) {
            const key = refKey || this.topDownData.ROOT[0].value;
            const refData = this.topDownData[this.topDownData.ROOT.filter(x=>x.value === key).map(x=>x.key)[0]].map(x=>x.value);
            return refData;
        },
        setReciptList(param){
            const vCustObj = param ? param : this.custParam;
console.log('setReciptList param: ', param);
console.log('setReciptList this.custParam: ', this.custParam);
            if(vCustObj.callCustSelItemList && vCustObj.callCustSelItemList.length>0){
                this.form.juminNo = vCustObj.callCustSelItemList[0].juminNo || '';
                this.form.propensity = vCustObj.callCustSelItemList[0].propensity || 'Default';
                this.form.propensityBigo = vCustObj.callCustSelItemList[0].propensityBigo || '';
                this.form.smsYn = vCustObj.callCustSelItemList[0].smsYn || '';
                this.form.telYn = vCustObj.callCustSelItemList[0].telYn || '';
                this.form.officeTelNo = vCustObj.callCustSelItemList[0].officeTelNo || '';
                this.form.etcTelNo1 = vCustObj.callCustSelItemList[0].etcTelNo1 || '';
                this.form.etcTelNo2 = vCustObj.callCustSelItemList[0].etcTelNo2 || '';
                // this.form.boundTelNo = vCustObj.callCustSelItemList[0].boundTelNo || '';
                this.form.positionNm = vCustObj.callCustSelItemList[0].positionNm || '';
            }

            if(vCustObj.callServiceEngineerFind && vCustObj.callServiceEngineerFind.length>0){
                this.form.asAgentNm = vCustObj.callServiceEngineerFind[0].asAgentNm;
                this.form.asAgentId = vCustObj.callServiceEngineerFind[0].asAgentId;
                this.form.userNm = vCustObj.callServiceEngineerFind[0].userNm;
                this.form.userId = vCustObj.callServiceEngineerFind[0].userId;
            //    this.form.areaAgent = vCustObj.callServiceEngineerFind[0].area2;
            }

            if(vCustObj.inType == 'IN_AS_ID'){
                this.showSave = false; // 저장버튼 숨김.

                this.data = [];
                this.subData = [];
                let vSubData = [];
                if(vCustObj.callAsCat && vCustObj.callAsCat.length>0){
                    vSubData = vCustObj.callAsCat || [];
                }

                if(vCustObj.callAsDetail && vCustObj.callAsDetail.length>0){
                    const vTemp = vCustObj.callAsDetail;
                    
                    vTemp.map((x,index)=>{
                        x.modelCd=x.modelNm;
                        x.subAsClass = x.subAsClassNm; 

                        // 고장증상
                        x.subData = vSubData.filter(y=>y.asDetailId == x.asDetailId)
                                            .map((z,index)=>{
                                                const vCat = (z.asCatFullNm || '').split(">");
                                                let vGbCd = ''; let vGbNm = '';
                                                if(vCat && vCat.length>=2){
                                                    vGbCd = vCat[1] || '';
                                                    vGbNm = vCat[2] || '';
                                                }

                                                const vSubObj = {
                                                    asCatId: z.asCatId,
                                                    chk: 'N',
                                                    gbCd: vGbCd,
                                                    gbNm: vGbNm,
                                                    id : index,
                                                    key: z.asCatId,
                                                    value: z.asCatNm,
                                                    description: z.description
                                                }
                                                
                                                return vSubObj;
                                            });
                                            
                        if(index===0){
                            this.subData =  _.cloneDeep(x.subData);
                        }
                        
                        return x;
                    });
                    
                    this.data = vTemp;
                    
                    console.log('setReciptList callAsDetail : ', vSubData, this.data);
                }

                console.log('====vCustObj: ', vCustObj);
                
                if(vCustObj.callAsMstSelList && vCustObj.callAsMstSelList.length>0){
                    this.form.callMemo = vCustObj.callAsMstSelList[0].callMemo || '';
                    this.form.visitMemo = vCustObj.callAsMstSelList[0].visitMemo || '';
                    this.form.allocationAsAgentId = vCustObj.callAsMstSelList[0].allocationAsAgentId || '';
                    this.form.asAgentId = this.form.allocationAsAgentId;
                    this.form.asAgentNm = vCustObj.callAsMstSelList[0].allocationAsAgentNm || '';
                    
                    let vAllocDt = vCustObj.callAsMstSelList[0].allocationDt;
                    vAllocDt = vAllocDt && vAllocDt.length >=19 ? vAllocDt.substring(0,19) : '';
                    this.form.allocationDt = vAllocDt;
                    
                    this.form.userNm = vCustObj.callAsMstSelList[0].allocationRepairNm || '';
                    this.form.userId = vCustObj.callAsMstSelList[0].allocationRepairId || '';
                    
                    const vVisitDt = vCustObj.callAsMstSelList[0].requestVisitDt || '';
                    
                    this.form.custNm = vCustObj.callAsMstSelList[0].boundCustNm; // 신고자
                    let vTelNo = vCustObj.callAsMstSelList[0].telNo || '';
                    if(vTelNo === ''){
                        vTelNo = vCustObj.callAsMstSelList[0].hpNo || '';
                    }

                    if(vTelNo === ''){
                        vTelNo = vCustObj.callAsMstSelList[0].boundTelNo || '';
                    }
                    this.form.telNo = _phone(vTelNo); // 전화번호
                    
                    const vTripGradeObj = vCustObj.tripGrade.filter(x=>x.key===vCustObj.callAsMstSelList[0].tripGrade);
                    if(vTripGradeObj && vTripGradeObj.length>0){
                        this.form.tripGrade = vTripGradeObj[0].value || '';
                    }
                    
                    if(vVisitDt.length>=19){
                        this.form.requestVisitDt = vVisitDt.substring(0,10);
                        
                        let vhh = vVisitDt.substring(11,13);
                        if(vhh == '09'){
                            vhh = '9';    
                        }
                        this.form.requestVistHh = vhh;

                        let vmm = vVisitDt.substring(14,16);
                        if(vmm == '00'){
                            vmm = '0';    
                        }
                            this.form.requestVistMm = vmm;
                    }
                    
                }

            } else {  // if(vCustObj.inType == 'IN_AS_ID')

                this.applySearchCond(vCustObj.popHeadInfo);
            }

            
        },
        applySearchCond(pObj){
            // 접수관리메뉴의 상단 조회조건이 있을경우 그 값으로 셋팅
            let vObj = pObj ? pObj : this.custParam.popHeadInfo;
            
            if(vObj){
                
                this.form.areaAgent = vObj.areaAgent ? vObj.areaAgent : ''; // 지역
                this.form.asAgentNm = vObj.asAgentNm; // 처리센터
                this.form.asAgentId = vObj.asAgentId; // 처리센터Id
                this.form.userNm = vObj.userId ? vObj.userNm : ''; // 처리기사
                this.form.userId = vObj.userId ? vObj.userId : ''; // 처리기사Id
                
                this.form.custNm = vObj.custNm; // 신고자
                let vTelNo = vObj.telNo || '';
                if(vTelNo === ''){
                    vTelNo = vObj.hpNo || '';
                }

                if(vTelNo === ''){
                    vTelNo = vObj.boundTelNo || '';
                }
                this.form.telNo = vTelNo; // 전화번호
            }
            
        }
    }
}
</script>

<style scoped>
.el-form {
    border: 1px solid #c7c7c7;
    padding: 10px;
    border-radius: 5px;
}
</style>